import * as Sentry from "@sentry/react-native"

export const withErrorBoundary = Sentry.withErrorBoundary
